import { JktextareaComponent } from './../jktextarea/jktextarea.component';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { TranslationService } from '../../services/jkAzure';
import { JkComboboxComponent } from '../jkcombobox/jkcombobox.component';

/**
 * 文字翻譯組件
 *
 * 提供文字翻譯功能的組件，支援多種語言互譯。
 * 此組件整合了翻譯服務，提供簡潔的使用者界面，
 * 讓用戶能夠方便地將文字翻譯成所需的語言。
 */
@Component({
  selector: 'app-jk-translate',
  standalone: true,
  imports: [JkComboboxComponent,
    JktextareaComponent,
    MaterialModule,],
  templateUrl: './jk-translate.component.html',
  styleUrl: './jk-translate.component.scss'
})
export class JkTranslateComponent {
  /** 要翻譯的文字 */
  translate: string = 'how are you?';

  /** 翻譯結果 */
  translateResult: string = '';

  /** 目標語言代碼 */
  to: string = 'zh-Hant';

  /**
   * 支援的語言列表
   * 包含語言代碼和語言名稱
   */
  languageList = [
    { id: 'zh-Hant', name: '繁體中文' },
    { id: 'zh-Hans', name: '简体中文' },
    { id: 'en', name: 'English' },
    { id: 'ja', name: '日本語' },
    { id: 'ko', name: '한국어' },
    { id: 'es', name: 'Español' },
    { id: 'fr', name: 'Français' },
    { id: 'de', name: 'Deutsch' },
    { id: 'pt', name: 'Português' },
    { id: 'ru', name: 'Русский' },
    { id: 'it', name: 'Italiano' },
    { id: 'vi', name: 'Tiếng Việt' },
    { id: 'th', name: 'ไทย' },
    { id: 'id', name: 'Bahasa Indonesia' },
    { id: 'ms', name: 'Bahasa Melayu' },
    { id: 'ar', name: 'العربية' },
    { id: 'hi', name: 'हिन्दी' },
    { id: 'tr', name: 'Türkçe' },
    { id: 'nl', name: 'Nederlands' },
    { id: 'sv', name: 'Svenska' },
    { id: 'pl', name: 'Polski' },
    { id: 'da', name: 'Dansk' },
    { id: 'fi', name: 'Suomi' },
    { id: 'no', name: 'Norsk' },
    { id: 'cs', name: 'Čeština' },
    { id: 'hu', name: 'Magyar' },
    { id: 'ro', name: 'Română' },
    { id: 'uk', name: 'Українська' },
    { id: 'el', name: 'Ελληνικά' },
    { id: 'bg', name: 'Български' },
    { id: 'he', name: 'עברית' },
  ];
  /** 翻譯服務 */
  public trans: TranslationService= inject(TranslationService);
  private cdr = inject(ChangeDetectorRef);

  /**
   * 建構函數
   */
  constructor() {
  }

  /**
   * 執行翻譯操作
   * 使用翻譯服務將輸入文字翻譯成選定的目標語言
   * @param $event 點擊事件
   */
  doTranslate($event: MouseEvent) {
    //this.trans = new TranslationService(this.http);
    this.trans.translate(this.translate,this.to).subscribe((res: any) => {
      this.translateResult = res[0].translations[0].text;
      this.cdr.markForCheck();
    });
  }

  /**
   * 執行文字轉語音操作
   * 注意：此功能尚未實現
   * @param $event 點擊事件
   */
  doTTS($event: MouseEvent) {
    throw new Error('Method not implemented.');
  }

}
